import { Box, Button, FormControl, Paper, Stack, TextField, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import { Field, Form, Formik } from "formik";
import { observer } from "mobx-react-lite";
import { ICCSearchForm } from "../../../../app/models/customer";

interface Props {
    toggleChangeHandler: (v: boolean) => void;
    loading: boolean;
    setCcSearchPredicate: (v: ICCSearchForm) => void;
    getCustomerCollectionPagedList: () => Promise<void>;
    ccSearchFormValues: ICCSearchForm;

}

function CollectionReportSearchFrm({ toggleChangeHandler, loading, setCcSearchPredicate, getCustomerCollectionPagedList, ccSearchFormValues }: Props) {

    // const { basicUserStore: { setCcSearchPredicate, getCustomerCollectionPagedList, ccSearchFormValues, loading } } = useStore();

    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box sx={{ mt: 2 }}>
            <Paper elevation={3} sx={{ width: 400, m: '0 auto', p: 2, borderRadius: 2 }}>
                <Formik
                    initialValues={ccSearchFormValues}
                    onSubmit={(values) => {
                        setCcSearchPredicate(values);
                        getCustomerCollectionPagedList();
                    }}
                >
                    {({ values,
                        handleChange }) => {
                        return (
                            <Form autoComplete='off' >
                                <Stack direction={'column'} spacing={.3}>
                                    <Stack direction={'row'} spacing={.3} justifyContent={matches ? 'space-around' : 'flex-start'}>
                                        <FormControl>
                                            <Tooltip title="Click to get old collection first" placement="top-start">
                                                <label>Click to Sort by {!values.orderBy ? 'Latest first' : 'Oldest first'}</label>
                                            </Tooltip>
                                            <Field
                                                type="checkbox"
                                                id="orderBy"
                                                name="orderBy"
                                                className='checkBox100'
                                            />
                                        </FormControl>
                                    </Stack>
                                    <FormControl sx={{ mt: 2 }}>
                                        {/* <Tooltip title="Search by Ko-number" placement="top-start">
                                        <label>Ko-Number</label>
                                    </Tooltip> */}
                                        <Field
                                            type="text"
                                            component={TextField}
                                            id="koNumber"
                                            name="koNumber"
                                            placeholder="Ko Number"
                                            onChange={handleChange}
                                            value={values.koNumber}
                                            variant="outlined"
                                            size="small"
                                        />
                                    </FormControl>
                                    <FormControl sx={{ mt: 2 }}>
                                        {/* <Tooltip title="Search by Reference number" placement="top-start">
                                        <label>Reference Number</label>
                                    </Tooltip> */}
                                        <Field
                                            type="text"
                                            component={TextField}
                                            id="refNr"
                                            name="refNr"
                                            placeholder="Reference Number"
                                            onChange={handleChange}
                                            value={values.refNr}
                                            variant="outlined"
                                            size="small"
                                        />
                                    </FormControl>
                                    <FormControl sx={{ mt: 2 }}>
                                        {/* <Tooltip title="Search by Company Name" placement="top-start">
                                        <label>Company name</label>
                                    </Tooltip> */}
                                        <Field
                                            type="text"
                                            component={TextField}
                                            id="companyName"
                                            name="companyName"
                                            placeholder="Company Name"
                                            onChange={handleChange}
                                            value={values.companyName}
                                            variant="outlined"
                                            size="small"
                                        />
                                    </FormControl>
                                    <FormControl sx={{ mt: 2 }}>
                                        {/* <Tooltip title="Search by City" placement="top-start">
                                        <label>City</label>
                                    </Tooltip> */}
                                        <Field
                                            type="text"
                                            component={TextField}
                                            id="city"
                                            name="city"
                                            placeholder="City"
                                            onChange={handleChange}
                                            value={values.city}
                                            variant="outlined"
                                            size="small"
                                        />
                                    </FormControl>
                                    <FormControl sx={{ mt: 2 }}>
                                        {/* <Tooltip title="Search by country" placement="top-start">
                                        <label>Country</label>
                                    </Tooltip> */}
                                        <Field
                                            type="text"
                                            component={TextField}
                                            id="country"
                                            name="country"
                                            placeholder="Country"
                                            onChange={handleChange}
                                            value={values.country}
                                            variant="outlined"
                                            size="small"
                                        />
                                    </FormControl>
                                    <Button
                                        type="submit"
                                        size={"small"}
                                        variant="contained"
                                        color="primary"
                                        sx={{ height: 40, mt: 4 }}
                                        disabled={loading}
                                    >
                                        Search
                                    </Button>
                                    <Button
                                        type="button"
                                        size={"small"}
                                        variant="contained"
                                        color="secondary"
                                        sx={{ height: 40, mt: 4 }}
                                        disabled={loading}
                                        onClick={() => toggleChangeHandler(false)}
                                    >
                                        Close filter
                                    </Button>
                                    {/* {matches ? <IconButton
                                    type="submit"
                                    disabled={!status.includes(ideal)}
                                    color="primary"
                                >
                                    <SearchIcon />
                                </IconButton>
                                    :
                                    <Button
                                        type="submit"
                                        disabled={!status.includes(ideal)}
                                        size={"small"}
                                        variant="contained"
                                        color="primary"
                                        sx={{ height: 40, top: 24}}
                                    >
                                        Find
                                    </Button>
                                } */}
                                </Stack>
                            </Form>
                        );
                    }}
                </Formik>
            </Paper>
        </Box>
    )
}

const CollectionReportSearchForm = observer(CollectionReportSearchFrm);
export default CollectionReportSearchForm;